const mailgunSubmitForm = async (event, setMessage, setErrorMessage) => {
	event.preventDefault();

	const { target: form } = event;
	const formData = new FormData(form);
	const reCAPTCHAValue = form['g-recaptcha-response'].value;
	const requiredInputNames = ['name', 'email', 'age', 'location'];

	let isValidated = true;
	let error = `Correct the following errors and attempt to resubmit the form: <br />`;

	// Check that all required fields have something in them
	Object.keys(form.elements).forEach((key) => {
		const input = form[key];
		const inputName = input.getAttribute('name');
		const hasRequired = input.hasAttribute('required');
		let hasRequiredFieldName = false;

		// Check the list of inputs that are required globally
		requiredInputNames.forEach((requiredInputName) => {
			if (inputName === requiredInputName) {
				hasRequiredFieldName = true;
			}
		});

		if (hasRequired || hasRequiredFieldName) {
			if (!input.value || input.value === '' || input.value === ' ') {
				error = `${error}Please supply a value for ${inputName} field above. <br />`;
				isValidated = false;
			}
		}
	});

	// Check that the reCAPTCHA field has a value.
	if (!reCAPTCHAValue) {
		error = `${error}Please check the reCAPTCHA checkbox.<br />`;
		isValidated = false;
	}

	if (isValidated) {
		await fetch(form.action, {
			method: 'POST',
			body: formData,
		})
			.then((res) => {
				if (res.status === 200) {
					res.json().then((data) => setMessage(data.message));
				} else if (res.status === 500) {
					res.json().then((data) => {
						console.error(data.message);
						setErrorMessage(
							`There was an error. Please try again or contact us directly at (905) 850-3701.`
						);
					});
				} else if (res.status === 413) {
					setErrorMessage(`${res.statusText}: Please upload smaller files.`);
				} else if (res.status === 422) {
					res.json().then((data) => setErrorMessage(`${data.message}`));
				} else {
					setErrorMessage(
						`There was an error. Please try again or contact us directly at (905) 850-3701.`
					);
				}
			})
			.catch((err) => {
				console.error(err);
				return setErrorMessage(
					`There was an error. Please try again or contact us directly at (905) 850-3701.`
				);
			});
	} else {
		setErrorMessage(error);
	}
};

export default mailgunSubmitForm;
